import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/Ratio/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Ratio',
  field: 'Number',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/1AddOrMultiply" */ './1AddOrMultiply')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/2UseRatioLanguage" */ './2UseRatioLanguage')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Ratio/3IntroductionToTheRatioSymbol" */ './3IntroductionToTheRatioSymbol'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Ratio/4RatioAndFractions" */ './4RatioAndFractions'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/5ScaleDrawing" */ './5ScaleDrawing')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/6UseScaleFactors" */ './6UseScaleFactors')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/7SimilarShapes" */ './7SimilarShapes')
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Ratio/8RatioProblems" */ './8RatioProblems')
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Ratio/9ProportionProblems" */ './9ProportionProblems'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () => import(/* webpackChunkName: "Year6/Spring/Ratio/10Recipes" */ './10Recipes')
    })
  ]
});
export default Block;
